export const calculatePrice = (reservation, reservationLength, app) => {
    const activeCalendar = app?.state?.activeCalendar;
    
    // Default prices for camping
    let settings = {
        price_person_adult: 5,
        price_person_child: 3,
        price_tent: 4,
        price_car: 3,
        price_caravan: 10,
        price_stay_day_adult: 3,
        price_stay_day_child: 2
    };

    if (activeCalendar && activeCalendar.settings) {
        let calSettings = {};
        if (typeof activeCalendar.settings === 'object') {
            calSettings = activeCalendar.settings;
        } else {
            try {
                calSettings = JSON.parse(activeCalendar.settings);
            } catch (e) {
                console.error("Error parsing camping settings", e);
            }
        }
        settings = { ...settings, ...calSettings };
    }

    const isDayStay = reservation.type_of_stay === 'day';
    const adults = parseInt(reservation.adults_count) || 0;
    const children = parseInt(reservation.children_count) || 0;
    const tents = parseInt(reservation.tents_count) || 0;
    const cars = parseInt(reservation.cars_count) || 0;
    const caravans = parseInt(reservation.caravans_count) || 0;

    let totalPrice = 0;

    if (isDayStay) {
        // Daily stay calculation (distinguish between adult and child)
        totalPrice = (adults * settings.price_stay_day_adult);
        totalPrice += (children * settings.price_stay_day_child);
        totalPrice += (cars * settings.price_car);
    } else {
        // Overnight stay (at least 1 night)
        const nights = Math.max(1, reservationLength - 1);
        
        let dailyPrice = 0;
        dailyPrice = adults * settings.price_person_adult;
        dailyPrice += children * settings.price_person_child;
        dailyPrice += tents * settings.price_tent;
        dailyPrice += cars * settings.price_car;
        dailyPrice += caravans * settings.price_caravan;
        
        totalPrice = dailyPrice * nights;
    }

    return totalPrice;
};
